import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationsService } from '../services';
import './Notifications.css';

export default function Notifications() {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) loadNotifications();
  }, [open]);

  useEffect(() => {
    // Polling: atualiza notificações a cada 20s quando o painel está aberto
    if (!open) return;
    const interval = setInterval(() => {
      loadNotifications();
    }, 20000);
    return () => clearInterval(interval);
  }, [open]);

  const loadNotifications = async () => {
    setLoading(true);
    try {
      const resp = await notificationsService.getNotifications();
      setNotifications(resp.data.notifications || []);
    } catch (err) {
      console.error('Erro ao carregar notificações', err);
    } finally {
      setLoading(false);
    }
  };

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const handleMarkRead = async (id) => {
    try {
      await notificationsService.markNotificationRead(id);
      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)));
    } catch (err) {
      console.error('Erro ao marcar notificação como lida', err);
    }
  };

  const handleClickNotification = async (n) => {
    // marca como lida localmente e no servidor
    try {
      if (!n.is_read) {
        await notificationsService.markNotificationRead(n.id);
        setNotifications((prev) => prev.map((x) => (x.id === n.id ? { ...x, is_read: true } : x)));
      }
    } catch (err) {
      console.error('Erro ao marcar notificação como lida', err);
    }

    // parse data payload (pode ser string JSON)
    let payload = {};
    try {
      payload = typeof n.data === 'string' ? JSON.parse(n.data) : n.data || {};
    } catch (e) {
      payload = {};
    }

    const userType = localStorage.getItem('user_type');

    // Navegação contextual com query params simples
    switch (n.type) {
      case 'REWARD_REDEEMED':
        if (userType === 'parent') {
          navigate(`/parent-dashboard?tab=redemptions&redemption=${payload.redemption_id || ''}`);
        } else {
          navigate(`/child-dashboard?tab=history&redemption=${payload.redemption_id || ''}`);
        }
        break;
      case 'REWARD_DELIVERED':
        navigate(`/child-dashboard?tab=history&redemption=${payload.redemption_id || ''}`);
        break;
      case 'TASK_SUBMITTED':
        // parent should review
        navigate(`/parent-dashboard?tab=review&completion=${payload.completion_id || ''}`);
        break;
      case 'TASK_REVIEWED':
        // child should see task status
        navigate(`/child-dashboard?tab=tasks&task=${payload.task_id || ''}`);
        break;
      case 'TASK_ASSIGNED':
        navigate(`/child-dashboard?tab=tasks&task=${payload.task_id || ''}`);
        break;
      default:
        // fallback: abrir dashboard correspondente
        if (userType === 'parent') navigate('/parent-dashboard');
        else navigate('/child-dashboard');
    }

    // fecha painel
    setOpen(false);
  };

  return (
    <div className="notifications-root">
      <button className="notif-bell" onClick={() => setOpen(!open)} title="Notificações">
        🔔
        {unreadCount > 0 && <span className="notif-count">{unreadCount}</span>}
      </button>

      {open && (
        <div className="notif-panel">
          <div className="notif-header">
            <strong>Notificações</strong>
            <button onClick={loadNotifications} className="refresh-btn">
              🔄
            </button>
          </div>

          {loading && <div className="notif-loading">Carregando...</div>}

          {!loading && notifications.length === 0 && <div className="notif-empty">Sem notificações</div>}

          <ul className="notif-list">
            {notifications.map((n) => (
              <li
                key={n.id}
                className={`notif-item ${n.is_read ? 'read' : 'unread'}`}
                onClick={() => handleClickNotification(n)}
                style={{ cursor: 'pointer' }}
              >
                <div className="notif-message">{n.message}</div>
                <div className="notif-meta">
                  <small>{new Date(n.created_at).toLocaleString()}</small>
                  {!n.is_read && (
                    <button
                      className="mark-read"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        handleMarkRead(n.id);
                      }}
                    >
                      Marcar lida
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
